
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evaluation/[[...slug]]",
      function () {
        return require("private-next-pages/evaluation/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evaluation/[[...slug]]"])
      });
    }
  